import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
  adminId: string | null;
  login: (token: string, adminId: string) => void;
  logout: () => void;
  setToken: (token: string) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      token: null,
      adminId: null,

      login: (token, adminId) =>
        set({
          isAuthenticated: true,
          token,
          adminId,
        }),

      logout: () =>
        set({
          isAuthenticated: false,
          token: null,
          adminId: null,
        }),

      setToken: (token) =>
        set({
          token,
          isAuthenticated: !!token,
        }),
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        isAuthenticated: state.isAuthenticated,
        token: state.token,
        adminId: state.adminId,
      }),
    }
  )
);
